import React from 'react';

const Col = ({ children }) => {
  return <div className={'col'}>{children}</div>;
};

export default Col;
